export enum SnackbarVariants {
  "SUCCESS" = "success",
  "ERROR" = "error",
  "WARNING" = "warning",
  "INFO" = "info",
  "LOADING" = "loading",
}
